import axiosInstance from '@/utils/axios';
import {SharedListUrlOptions} from '@/utils/generateSharedListUrl';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';

/**
 * Uses the configured (token-injecting) axios instance instead of
 * `window.open`, which can't carry the auth headers the endpoint requires.
 */
export async function downloadCsvFile(
  path: string,
  params: Record<string, string>,
  fileName: string
): Promise<void> {
  try {
    const {data} = await axiosInstance.get<Blob>(path, {
      params,
      responseType: 'blob',
    });

    const objectUrl = URL.createObjectURL(data);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(objectUrl);
  } catch {
    raiseFlashMessage({
      status: 'error',
      message: translate('Download failed — please try again'),
    });
  }
}

export default function downloadAuthenticatedCsv(
  type: SharedListUrlOptions['type'],
  refId: string,
  fileName = `creators__${new Date().toISOString().slice(0, 10)}.csv`
): Promise<void> {
  return downloadCsvFile(
    '/shared_list_creators/csv',
    {type, ref_id: refId},
    fileName
  );
}
